module.exports = __webpack_public_path__ + "img/1527522619.052df56f.jpg";